import styled from "@emotion/styled";
import {faFileExcel, faFileZipper} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Span from "@jumbo/shared/Span";
import {Card, CircularProgress, Typography} from "@mui/material";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import {DateTimeFormatter} from "app/utils/date";
import * as ExcelJS from "exceljs";
import React, {useState} from "react";
import {toast} from "react-toastify";
import {axios_tenant} from "../../../axios";


const Item = styled(Span)(({theme}) => ({
    padding: theme.spacing(0, 0.1),
}));



const ArchiveCard = ({archiveItem}) => {

    const parts = archiveItem.packageUrl.split("/");
    const packageName = parts[parts.length-1];
  

    const split_parts = packageName.split('_');
    const partsExceptLast = split_parts.slice(0, split_parts.length - 1);
    const fileName = partsExceptLast.join('_');

   

    const [loading,setLoading] = useState(false);

    const dateObject = new Date(archiveItem.runOn);

    const generateExcel = async(resultArray = [], applicationNo) => {
       const workbook = new ExcelJS.Workbook();

        const worksheet = workbook.addWorksheet('QC Results',{views:[{showGridLines:false}]});
        
        const currentDate = new Date();

        const dataArray = [
            ["Application No.:", applicationNo],
            ["QC Date:", `${currentDate.toLocaleDateString()} ${currentDate.toLocaleTimeString()}`],
            ["QC by:", localStorage.getItem("tenant_username")],
            [],
            [],
            ["Document Name","Discrepancy","Value Found","Correct Value"]
        ];

        dataArray.map((p,i) => worksheet.addRow(p));

        for (let i=1;i<=3;i++){
          const row = worksheet.getRow(i);
          row.eachCell(cell => {
           
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
        })
      }
        
        const row = worksheet.getRow(6);
        row.eachCell(cell => {
        cell.font = { bold: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        });



        for (const p of resultArray) {


            const row = worksheet.addRow([p.category,p.name, p.foundValue, p.trueValue]);


            for (let i = 1; i <= 4; i++) {
                const cell = row.getCell(i);
               
                if (p.isCorrect !== undefined) {
                    if (p.isCorrect) {
                        cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'B7E1CD' }
                            };
                        cell.border = {
                              top: { style: 'thin' },
                              left: { style: 'thin' },
                              bottom: { style: 'thin' },
                              right: { style: 'thin' }
                            };
                          
                    }
                    else {
                        cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'E57373' }
                            };
                        cell.border = {
                              top: { style: 'thin' },
                              left: { style: 'thin' },
                              bottom: { style: 'thin' },
                              right: { style: 'thin' }
                            };
                    }
                } else {
                    if (!!p.foundValue) {
                        cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'B7E1CD' }
                            };
                        cell.border = {
                              top: { style: 'thin' },
                              left: { style: 'thin' },
                              bottom: { style: 'thin' },
                              right: { style: 'thin' }
                            };
                           
                    }
                    else {
                        cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'E57373' }
                            };
                        cell.border = {
                              top: { style: 'thin' },
                              left: { style: 'thin' },
                              bottom: { style: 'thin' },
                              right: { style: 'thin' }
                            };
                    }
                }
            }
        }


        worksheet.columns.forEach(column => {
            column.width = 30;
          });


          workbook.xlsx.writeBuffer()
          .then(buffer => {
               const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
               const url = URL.createObjectURL(blob);
               const a = document.createElement('a');
               a.href = url;
               a.download = `QC_Results_${archiveItem.applicationNo}.xlsx`;
      
             
             a.click();
              toast.success("QC Results excel file downloaded");
              })
            .catch(err => {

             toast.error("Failed to download excel file");
          });
  
  }


   const handleArchiveDownload = (id) =>{


       axios_tenant.get(`/qc/archive/${id}`)
        .then((res)=>{
            generateExcel(res.data.results,res.data.applicationNo);
           
        })
        .catch(err =>{
            toast.error("Archive excel download failed")
        })
   }

   const handlePackageDownload = () =>{

            downloadZipFileFromWeb(packageName);
   }

   const downloadZipFileFromWeb = (packageName) => {
    setLoading(true);
       axios_tenant.get(`/qc/archive-package/${packageName}`, {
        responseType: 'arraybuffer'
    })
    .then((res)=>{
        setLoading(false);
       const blob = new Blob([res.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
    

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${fileName}`; 

      document.body.appendChild(a);

      
      a.click();

      toast.success("Package zip file downloaded"); 
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    })
    .catch(err =>{
        setLoading(false);
        toast.error("Download failed"); 
    })

  };
   

  

    return (
        <Card sx={{mb: 1, width: {xs:1.0,md:900,sm:300}}} >
            <Stack direction={"row"} alignItems={"center"} spacing={14} sx={{p: theme => theme.spacing(1, 2)}} >
                <Item
                    sx={{
                        flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                        alignSelf: 'flex-center',
                        flexBasis: {md: '28%', lg: '18%'},
                        display: {xs: 'none', md: 'block'}
                    }}
                >
                    <Typography variant={"h6"} mt={1} lineHeight={1.25} textAlign={"left"}>{archiveItem.applicationNo}</Typography>
                </Item>

                <Item
                    sx={{
                       
                        flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                        alignSelf: 'flex-center',
                        flexBasis: {md: '28%', lg: '18%'},
                        display: {xs: 'none', md: 'block'}
                    }}
                >
                    <Typography variant={"h6"} mt={1} lineHeight={1.25} textAlign={"center"}>{archiveItem.noOfErrors}</Typography>
                </Item>

                <Item
                    sx={{
                       
                        flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                        alignSelf: 'flex-center',
                        flexBasis: {md: '28%', lg: '18%'},
                        display: {xs: 'none', md: 'block'}
                    }}
                >
                    <Typography variant={"h6"} mt={1} lineHeight={1.25}>{DateTimeFormatter(dateObject)}</Typography>
                </Item>

                <Item
                    sx={{
                       
                        flex: {xs: 1, md: '0 1 45%', lg: '0 1 35%'},
                        alignSelf: 'flex-center',
                        flexBasis: {md: '28%', lg: '18%'},
                        display: {xs: 'none', md: 'block'}
                    }}
                >
                    <Typography variant={"h6"} mt={1} lineHeight={1.25} textAlign={"left"}>
                  
                    <Tooltip title="QC 371 Results">
                        <FontAwesomeIcon icon={faFileExcel} size="2x" style={{cursor:"pointer"}} onClick={()=>handleArchiveDownload(archiveItem.id)}/>
                    </Tooltip>
                        {" "}
                    
                        {loading ? 
                        <Tooltip title="Downloading..."><CircularProgress sx={{ color: 'black'}} size="15%"/> </Tooltip>
                        :
                        <Tooltip title={`${fileName}`}>
                            <FontAwesomeIcon icon={faFileZipper} size="2x" style={{cursor:"pointer"}} onClick={handlePackageDownload}/>
                        </Tooltip>
                        }
                        
                    </Typography>
                </Item>
            </Stack>
        </Card>
    );
};

export default ArchiveCard;